// for formatCurrency localstorage method
export function formatedCurrency(amount, preferences = {}) {
  if (!preferences || Object.keys(preferences).length === 0) {
    try {
      const stored = JSON.parse(localStorage.getItem("tenantCurrency"));
      if (stored) preferences = stored;
    } catch (error) {
      console.error("Failed to parse tenantCurrency from localStorage", error);
    }
  }

  const {
    symbol = "",
    digitSeparator = "", // "comma" | "dot" | "space"
    decimalPlaces = 0,
  } = preferences;

  const decimals = Number(decimalPlaces);

  if (amount == null || isNaN(amount)) return `${symbol} 0`;

  // Always convert to fixed decimal string
  const fixed = Number(amount).toFixed(decimals); // e.g., "71.0000"
  const [intPartRaw, decimalPartRaw] = fixed.split(".");

  // Apply thousand separator
  let intPart = "";
  switch (digitSeparator) {
    case "dot":
      intPart = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      break;
    case "space":
      intPart = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      break;
    case "comma":
    default:
      intPart = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      break;
  }

  // Determine decimal symbol
  const decimalSymbol = digitSeparator === "dot" ? "," : ".";

  const finalValue =
    decimals > 0
      ? `${symbol} ${intPart}${decimalSymbol}${decimalPartRaw}`
      : `${symbol} ${intPart}`;

  return finalValue;
}


